import portalApi from "../api/apiSlice";
import { setUser } from "./authSlice";

const AuthApi = portalApi.injectEndpoints({
  endpoints: (builder) => ({
    register: builder.mutation({
      query: (body) => ({
        url: "register",
        method: "POST",
        body,
      }),
      async onQueryStarted(...args) {
        setTokenToStore(...args);
      },
    }),

    login: builder.mutation({
      query: (body) => ({
        url: "login",
        method: "POST",
        body,
      }),
      async onQueryStarted(...args) {
        setTokenToStore(...args);
      },
    }),
  }),
});

async function setTokenToStore(data, { dispatch, queryFulfilled }) {
  try {
    const { data } = await queryFulfilled;
    const resultData = {
      accessToken: data?.accessToken,
      email: data?.user?.email,
      name: data?.user?.name,
      role: data?.user?.role,
      student_id: data?.user?.id,
    };

    dispatch(setUser(resultData));
  } catch (error) {}
}

export const { useRegisterMutation, useLoginMutation } = AuthApi;
